<template>
  <slot
    :show="show"
    :accordionItemId="accordionItemId"
    :toggle="toggle"
    :close="close">
  </slot>
</template>

<script>
import {defineComponent, ref} from 'vue';

export default defineComponent({
  name: 'AccordionItem',
  props: {
    accordionItemId: {
      type: String,
      default: null,
    }
  },
  setup() {
    const show = ref(false);

    /**
     * toggles the accordion item
     */
    const toggle = () => {
      show.value = !show.value;
    }

    /**
     * closes accordion and set show to false
     */
    const close = () => {
      show.value = false;
    };

    return {
      show,
      toggle,
      close
    }
  }
});
</script>
